// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import './App.css';
import './pages/styles.css';

// Import all pages
import Home from './pages/Home';
import About from './pages/About';
import DonorsPartners from './pages/DonorsPartners';
import GetInvolved from './pages/GetInvolved';
import Events from './pages/Events';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Donate from './pages/Donate';
import Children from './pages/Children';
import NotFound from './pages/NotFound';
import DonationSuccess from './pages/DonationSuccess';
import MpesaPayment from './pages/MpesaPayment';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';

// Import components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Wrapper component to conditionally show footer
function AppContent() {
  const location = useLocation();
  
  // Pages where footer should be hidden
  const hideFooterPaths = [
    '/mpesa-payment',
    '/donation-success',
    '/donation-waiting'
  ];
  
  const shouldHideFooter = hideFooterPaths.includes(location.pathname);

  return (
    <div className="App">
      <Navbar />
      <main id="main-content" role="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/donors-partners" element={<DonorsPartners />} />
          <Route path="/get-involved" element={<GetInvolved />} />
          <Route path="/events" element={<Events />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/children" element={<Children />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/donation-success" element={<DonationSuccess />} />
          <Route path="/mpesa-payment" element={<MpesaPayment />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </main>
      {!shouldHideFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <Router>
          <ScrollToTop />
          <AppContent />
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;